import "core-js/modules/es.array.push.js";
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5d96d14a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "user-avatar"
};
const _hoisted_2 = {
  class: "avatar-conent"
};
const _hoisted_3 = {
  class: "avatar-header"
};
const _hoisted_4 = {
  class: "name"
};
const _hoisted_5 = {
  class: "tenant"
};
const _hoisted_6 = {
  class: "avatar-body"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "个人设置", -1));
import store from "@/store";
import { logout } from "@/service/common/login";
import { useRouter } from "vue-router";
import { reactive, ref } from "vue";
export default {
  __name: 'UserAvatar',
  setup(__props) {
    const router = useRouter();
    const user = JSON.parse(localStorage.getItem("USER"));
    const logouts = () => {
      // 发送请求
      logout().then(res => {
        if (res) {
          if (res.code == 10000) {
            // 删除缓存
            store.dispatch("logout");
            // 跳转登录页
            router.push("/account/login");
          }
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_avatar = _resolveComponent("el-avatar");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_ArrowRight = _resolveComponent("ArrowRight");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_router_link = _resolveComponent("router-link");
      const _component_el_popover = _resolveComponent("el-popover");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_popover, {
        width: 220,
        placement: "right-start",
        "popper-style": "box-shadow: rgb(14 18 22 / 35%) 0px 10px 38px -10px, rgb(14 18 22 / 20%) 0px 10px 20px -15px; padding: 20px;"
      }, {
        reference: _withCtx(() => [_unref(user).avatar ? (_openBlock(), _createBlock(_component_el_avatar, {
          key: 0,
          src: _unref(user).avatar
        }, null, 8, ["src"])) : (_openBlock(), _createBlock(_component_el_avatar, {
          key: 1,
          src: "https://lib.eqh5.com/eqx.layout/images/head_portrait.svg"
        }))]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_unref(user).avatar ? (_openBlock(), _createBlock(_component_el_avatar, {
          key: 0,
          src: _unref(user).avatar
        }, null, 8, ["src"])) : (_openBlock(), _createBlock(_component_el_avatar, {
          key: 1,
          src: "https://lib.eqh5.com/eqx.layout/images/head_portrait.svg"
        })), _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(user).username), 1), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_tag, {
          "disable-transitions": "true"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(user).role), 1)]),
          _: 1
        })])]), _createElementVNode("div", _hoisted_6, [_createElementVNode("ul", null, [_createElementVNode("li", null, [_createVNode(_component_router_link, {
          to: "/system/personcenter"
        }, {
          default: _withCtx(() => [_hoisted_7, _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_ArrowRight)]),
            _: 1
          })]),
          _: 1
        })])])]), _createElementVNode("div", {
          class: "avatar-footer"
        }, [_createElementVNode("div", {
          class: "logout",
          onClick: logouts
        }, "退出登录")])])]),
        _: 1
      })]);
    };
  }
};